// Column masonry that keeps reading order left-to-right: item i goes to
// column i % n, so the newest entries always sit across the top row.
import { Box, Flex, useBreakpointValue } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import { EASE } from "../theme";
import JournalCard from "./JournalCard";

const MotionBox = motion(Box);

const Masonry = ({ entries, columns = { base: 1, md: 2, xl: 3 }, gap = 5 }) => {
  const n = useBreakpointValue(columns, { ssr: false }) || 1;
  const cols = [...Array(n)].map(() => []);
  entries.forEach((e, i) => cols[i % n].push([e, i]));

  return (
    <Flex gap={gap} align="flex-start">
      {cols.map((col, c) => (
        <Flex key={c} direction="column" gap={gap} flex="1" minW={0}>
          <AnimatePresence initial={false}>
            {col.map(([e, i]) => (
              <MotionBox
                key={e.id}
                layout="position"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                exit={{ opacity: 0, scale: 0.97 }}
                transition={{ duration: 0.7, delay: Math.min(i, 6) * 0.05, ease: EASE }}
              >
                <JournalCard entry={e} />
              </MotionBox>
            ))}
          </AnimatePresence>
        </Flex>
      ))}
    </Flex>
  );
};

export default Masonry;
